// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_gn-a";
export var fulfillmentFormRail = "_gn-9";
export var headerTitleRow = "_gn-c";
export var orderDetailsWrapper = "_gn-7";
export var orderLinkTrigger = "_gn-2";
export var paymentInformationGrid = "_gn-h";
export var paymentSummaryColumn = "_gn-i";
export var shipmentContainer = "_gn-b";
export var shipmentDetailsMainPane = "_gn-8";
export var shipmentNavigationCard = "_gn-5";
export var shipmentNavigationRail = "_gn-3";
export var shipmentNavigationRailHeader = "_gn-4";
export var shipmentSummaryFact = "_gn-e";
export var shipmentSummaryGrid = "_gn-d";
export var shipmentSummaryMetadataRow = "_gn-f";
export var shipmentSummaryTags = "_gn-g";
export var shipmentWorkspace = "_gn-0";
export var shipmentWorkspaceContent = "_gn-6";
export var shipmentWorkspaceHeader = "_gn-1";